import { render } from "./MessageToast.vue?vue&type=template&id=bc2886b6&scoped=true"
import script from "./MessageToast.vue?vue&type=script&lang=ts"
export * from "./MessageToast.vue?vue&type=script&lang=ts"

import "./MessageToast.vue?vue&type=style&index=0&id=bc2886b6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-bc2886b6"

export default script